import { render, staticRenderFns } from "./VehicleProvisionRequestAgreed.vue?vue&type=template&id=62a85e3b&scoped=true&"
import script from "./VehicleProvisionRequestAgreed.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionRequestAgreed.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionRequestAgreed.vue?vue&type=style&index=0&id=62a85e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a85e3b",
  null
  
)

export default component.exports
import {QCardSection,QField,QItem,QList,QItemSection,QItemLabel,QBtn,QTooltip,QSelect,QInput,QCheckbox,QBadge,QIcon} from 'quasar'
component.options.components = Object.assign({QCardSection,QField,QItem,QList,QItemSection,QItemLabel,QBtn,QTooltip,QSelect,QInput,QCheckbox,QBadge,QIcon}, component.options.components || {})
